<template>
  <form @submit.prevent="continueAnyway">
    <app-step-primary-subscriber>
      <h2>It looks like "{{fullName}}" might already be in the system</h2>
      <p>
        Lorem ipsum dolor sit amet, sit detraxit efficiantur ne, quando tollit te mel. Illum luptatum forensibus mel no, eum id populo salutandi prodesset. Sed ex nisl reque eruditi, ignota mnesarchum vis te. Eros modus accusam ex mei, altera pertinax quo ut.
      </p>
    </app-step-primary-subscriber>
    <app-advanced-table-section
      class="_bt1"
      :title="tableTitle"
      :headers="headers"
      :items="items"
      :clickable="true"
      @cellClicked="memberClicked">

      <v-alert
        :value="subgroupSecurityViolation"
        class="_mts"
        type="error"
      >
        There are members who match your criteria that you do not have permission to view.
      </v-alert>

      <!-- Actions -->
      <template #actions>
        <app-column-picker :headers='headers' @updateHeaders='updateHeaders'/>
      </template>

    </app-advanced-table-section>
    <div v-if="ssnMatch" container>
      <div class="announcement -warning _mbs">
        A member with a matching SSN was found
      </div>
    </div>
    <div v-if="healthIdMatch" container>
      <div class="announcement -warning _mbs">
        This member can not be updated due to the Client's Member ID matching an existing member.
      </div>
    </div>

    <div container v-if="ssnMatch || healthIdMatch">
      <div v-html="cloudCannonContent.footer"/>
    </div>

    <div class="_text-center _mbs">
      <async-button
        type="submit"
        class="btn --sm"
        :executing="submitting"
        :disabled="healthIdMatch || ssnMatch"
      >
        <template #buttonContent>
          <span>Continue Anyway</span>
        </template>
      </async-button>
    </div>
  </form>
</template>

<script>
  import AppStepPrimarySubscriber from './Steps/StepPrimarySubscriber'
  import AppAdvancedTableSection from '@sections/AdvancedTableSection.vue'
  import AppColumnPicker from '@molecules/ColumnPicker.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import DateHelper from '@mixins/DateHelper'
  import fetchable from '@mixins/fetchable'
  import CloudCannonable from '@mixins/CloudCannonable'

  import { mapState, mapGetters } from 'vuex'

  export default {
    components: {
      AppStepPrimarySubscriber,
      AppAdvancedTableSection,
      AppColumnPicker,
      AsyncButton
    },
    mixins: [
      DateHelper,
      fetchable,
      CloudCannonable
    ],
    data() {
      return {
        submitting: false,
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/member-found.json'
            },
            config: {
              root: true
            }
          }
        ],
        headers: [
          { text: 'Name', align: 'left', value: 'name' },
          { text: 'EyeMed Member ID', value: 'memberId' },
          { text: 'Client\'s Member ID', value: 'clientHealthId' },
          { text: 'Relationship', value: 'relationshipDescription' },
          { text: 'DOB', value: 'dateOfBirth' },
          { text: 'SSN', value: 'ssn' },
          { text: 'Status', value: 'memberStatus' }
        ]
      }
    },
    methods: {
      updateHeaders (headers) {
        this.headers = headers
      },
      memberClicked (info) {
        this.$router.push({
          name: 'member-details',
          params: {
            memberCk: info.memberCk
          }
        })
      },
      continueAnyway() {
        this.submitting = false
        this.$router.push({ name: 'primary-subscriber-details' })
      }
    },
    computed: {
      subgroupSecurityViolation () {
        return (
          this.$route.query.subgroupSecurityViolation === 'true' ||
          this.$route.query.subgroupSecurityViolation === true
        )
      },
      items() {
        return this.$store.state.addFamily.similarMembers.map((m) => {
          return {
            name: `${m.lastName}, ${m.firstName}`,
            memberId: m.eyemedMemberId,
            memberCk: m.memberCk,
            clientHealthId: m.clientHealthId,
            relationshipDescription: m.relationshipDescription,
            dateOfBirth: this.formatDate(m.dateOfBirth),
            ssn: m.ssn,
            memberStatus: m.memberStatus
          }
        })
      },
      tableTitle() {
        return `${this.items.length} Results found for "${this.fullName}"`
      },
      ...mapState('addFamily', {
        firstName: state => state.firstName,
        lastName: state => state.lastName,
        healthIdMatch: state => state.healthIdMatch,
        ssnMatch: state => state.ssnMatch
      }),
      ...mapGetters('addFamily', [
        'fullName'
      ])
    }
  }
</script>
